import { withPermission } from "app/auth/components/withPermission";
import Home from "../screens/Home";
import MeasurementFlow from "../screens/MeasurementFlowScreen";
import NoAccessScreen from "../../../shared/components/NoAccessScreen";
import DrugIntakeFlow from "../screens/DrugIntakeFlowScreen";
import DrugIntakeSubmitForm from "../screens/DrugIntakeSubmitFormScreen";
import DrugIntakeWindowSelect from "../screens/DrugIntakeWindowSelectScreen";
import QuestionnaireFlow from "../screens/QuestionnaireFlowScreen";
import ActivitySuccess from "../screens/ActivitySuccessScreen";
import RemeasurementStart from "../screens/RemeasurementStartScreen";
import RemeasurementSuccess from "../screens/RemeasurementSuccessScreen";
import WhoMeasured from "../screens/WhoMeasuredScreen";
import AlertEscalation from "../screens/AlertEscalationScreen";
import DeviceTroubleshooting from "../screens/DeviceTroubleshootingScreen";
import DeviceTroubleshootingResult from "../screens/DeviceTroubleshootingResultScreen";
import AppointmentHome from "../screens/AppointmentScreen";
import { TeleassistanceDetailScreen as TeleassistanceDetail } from "app/_modules/history";
import WherebyRoomHome from "../screens/WherebyRoomScreen";

export const HomeScreen = withPermission(
  Home,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const MeasurementFlowScreen = withPermission(
  MeasurementFlow,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const DrugIntakeFlowScreen = withPermission(
  DrugIntakeFlow,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const DrugIntakeSubmitFormScreen = withPermission(
  DrugIntakeSubmitForm,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const DrugIntakeWindowSelectScreen = withPermission(
  DrugIntakeWindowSelect,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const ActivitySuccessScreen = withPermission(
  ActivitySuccess,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const QuestionnaireFlowScreen = withPermission(
  QuestionnaireFlow,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const RemeasurementStartScreen = withPermission(
  RemeasurementStart,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const RemeasurementSuccessScreen = withPermission(
  RemeasurementSuccess,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const WhoMeasuredScreen = withPermission(
  WhoMeasured,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const AlertEscalationScreen = withPermission(
  AlertEscalation,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const DeviceTroubleshootingScreen = withPermission(
  DeviceTroubleshooting,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const DeviceTroubleshootingResultScreen = withPermission(
  DeviceTroubleshootingResult,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const AppointmentScreen = withPermission(
  AppointmentHome,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const WherebyRoomScreen = withPermission(
  WherebyRoomHome,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const TeleassistanceDetailScreen = withPermission(
  TeleassistanceDetail,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);
